import React, { useEffect, useState, useMemo, useRef } from "react";
import { Layout } from "antd";
import "leaflet/dist/leaflet.css";
import * as turf from "@turf/turf";
// import logo from "../assets/Logo T&G.png"; // not used when header is hidden
import chroma from "chroma-js";
import { Grid } from "antd";
import Papa from "papaparse";
import MapComponent from "./Mappa";
import SiderComponent from "./Sider"; // reused as popup card
import partner1 from "../assets/LogoExisES.png";
import partner2 from "../assets/partner2_ritagliato.svg";
import partner3 from "../assets/ONAIR_logo_hires.svg";
import partner4 from "../assets/Logo T&G.svg";
import partner5 from "../assets/Logo_Swhard_Blue_Yellow.svg";
import finanziatore1 from "../assets/finaziatore2.svg";
import finanziatore3 from "../assets/finaziatore1.svg";
import finanziatore4 from "../assets/finaziatore4.svg";
import { FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import BetwinLogo from "../assets/BETWIN-logo-senza-sfondo.svg";
import "../styles/GeoJson.css";
import { fetchTrafficCSV, fetchTrafficZoneData, fetchMapGeoJSON, fetchArchiZonaGeoJSON } from "../APIs/apiService";
const { useBreakpoint } = Grid;

const { Content } = Layout;

function GeoJson() {
  const [geoData, setGeoData] = useState(null);
  const [dbData, setDbData] = useState(null);
  const [selectedHash, setSelectedHash] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  // const [collapsed, setCollapsed] = useState(false);
  const [siderSection, setSiderSection] = useState();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [speedDomain, setSpeedDomain] = useState([0, 1]);
  const [colorScale, setColorScale] = useState(() =>
    chroma.scale(["red", "yellow", "green"]).domain([0, 1])
  );
  const [showDeckGL, setShowDeckGL] = useState(false);
  const [mapMode, setMapMode] = useState("mappa"); // 'mappa', 'genova', 'nuvola'
  const [footerOpen, setFooterOpen] = useState(true);
  const [radarSelected, setRadarSelected] = useState(false);
  const [isLoadingGeoData, setIsLoadingGeoData] = useState(true);
  const hasFetchedDbData = useRef(false);

  // Network view mode state (when no road is selected)
  const [networkViewCategory, setNetworkViewCategory] = useState(null); // 'velocita', 'congestion', 'anomaly'
  const [networkViewDate, setNetworkViewDate] = useState(null);
  const [networkViewTime, setNetworkViewTime] = useState(null);
  const [availableNetworkDates, setAvailableNetworkDates] = useState([]);
  const [availableNetworkTimes, setAvailableNetworkTimes] = useState([]);

  // Responsive footer height and handle size based on viewport/breakpoints
  const FOOTER_HEIGHT = screens.xl
    ? 86.8
    : screens.lg
    ? 86.8
    : screens.md
    ? 86.8
    : 86.8;
  // handle height no longer used (floating toggle replaces it)

  useEffect(() => {
    // Prevent multiple fetches
    if (hasFetchedDbData.current) {
      console.log("GeoJSON: Already fetched dbData, skipping...");
      return;
    }

    hasFetchedDbData.current = true;
    console.log("GeoJSON: Component mounted, fetching Traffic_5min.csv...");

    // Fetch CSV file and parse it using centralized API service
    fetchTrafficCSV()
      .then((csvText) => {
        console.log(
          "GeoJSON: Successfully fetched Traffic_5min.csv, parsing..."
        );

        // Parse CSV to JSON
        Papa.parse(csvText, {
          header: true,
          dynamicTyping: true,
          skipEmptyLines: true,
          complete: (results) => {
            console.log("GeoJSON: Successfully parsed CSV, setting dbData");
            setDbData(results.data);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
            // Fallback to old data
            fetchTrafficZoneData()
              .then((data) => {
                console.log(
                  "GeoJSON: Successfully fetched db_dati_zona.json (fallback), setting dbData"
                );
                setDbData(data);
              });
          },
        });
      })
      .catch((error) => {
        console.warn(
          "Failed to load Traffic_5min.csv, falling back to db_dati_zona.json:",
          error
        );
        return fetchTrafficZoneData()
          .then((data) => {
            console.log(
              "GeoJSON: Successfully fetched db_dati_zona.json (fallback), setting dbData"
            );
            setDbData(data);
          });
      });
  }, []);

  // Extract available dates and times for network view
  useEffect(() => {
    if (!dbData || dbData.length === 0) return;

    const dates = new Set();
    const times = new Set();

    dbData.forEach((d) => {
      if (d.timestamp_utc) {
        const [date, time] = d.timestamp_utc.split(" ");
        dates.add(date);
        times.add(time.split("+")[0]); // Remove timezone
      } else if (d.date) {
        dates.add(d.date.split("T")[0]);
      }
    });

    const sortedDates = Array.from(dates).sort();
    const sortedTimes = Array.from(times).sort();

    setAvailableNetworkDates(sortedDates);
    setAvailableNetworkTimes(sortedTimes);

    // Set initial date and time if available
    if (sortedDates.length > 0 && !networkViewDate) {
      setNetworkViewDate(sortedDates[0]);
    }
    if (sortedTimes.length > 0 && !networkViewTime) {
      setNetworkViewTime(sortedTimes[0]);
    }
  }, [dbData, networkViewDate, networkViewTime]);

  // Load GeoJSON only once and enrich with ALL data
  useEffect(() => {
    if (!dbData) {
      console.log("GeoJSON: Waiting for dbData...");
      return;
    }

    console.log("GeoJSON: Starting to load geo data...");
    setIsLoadingGeoData(true);

    // Try to fetch from new_data first, fallback to old data using centralized API service
    fetchMapGeoJSON()
      .then((data) => {
        try {
          const js = offsetSegmentiNegativi(data, 4);

          // Create a lookup map for faster access: hash -> array of all records
          const dataByHash = {};
          dbData.forEach((d) => {
            if (!dataByHash[d.hash]) {
              dataByHash[d.hash] = [];
            }
            dataByHash[d.hash].push(d);
          });

          const enriched = js.features.map((f) => {
            const allRecords = dataByHash[f.properties.hash] || [];

            // Store all records for this hash so we can filter later
            return {
              ...f,
              properties: {
                ...f.properties,
                allRecords: allRecords, // Store all data records
              },
            };
          });

          const fullGeo = { ...js, features: enriched };
          setGeoData(fullGeo);
          console.log("GeoJSON: Successfully loaded Map.geojson");
          setIsLoadingGeoData(false);
        } catch (processingError) {
          console.error("Error processing Map.geojson:", processingError);
          setIsLoadingGeoData(false);
          throw processingError;
        }
      })
      .catch((error) => {
        console.warn(
          "Failed to load Map.geojson, falling back to archi_zona.geojson:",
          error
        );

        // Fallback to old geojson
        return fetchArchiZonaGeoJSON()
          .then((data) => {
            try {
              const js = offsetSegmentiNegativi(data, 4);

              // Create a lookup map for faster access
              const dataByHash = {};
              dbData.forEach((d) => {
                if (!dataByHash[d.hash]) {
                  dataByHash[d.hash] = [];
                }
                dataByHash[d.hash].push(d);
              });

              const enriched = js.features.map((f) => {
                const allRecords = dataByHash[f.properties.hash] || [];

                return {
                  ...f,
                  properties: {
                    ...f.properties,
                    allRecords: allRecords,
                  },
                };
              });

              const fullGeo = { ...js, features: enriched };
              setGeoData(fullGeo);
              console.log("GeoJSON: Successfully loaded archi_zona.geojson (fallback)");
              setIsLoadingGeoData(false);
            } catch (processingError) {
              console.error("Error processing archi_zona.geojson:", processingError);
              setIsLoadingGeoData(false);
            }
          })
          .catch((fallbackError) => {
            console.error("Error loading GeoJSON (all attempts failed):", fallbackError);
            setIsLoadingGeoData(false);
          });
      });
  }, [dbData]); // Only depend on dbData, load once!

  // Separate effect to recalculate colors based on network view settings
  useEffect(() => {
    if (!geoData || !geoData.features || geoData.features.length === 0) return;

    console.log("Recalculating color scale...");

    // Get the current values for coloring based on network view settings
    const values = geoData.features.map((f) => {
      const allRecords = f.properties.allRecords || [];

      // Find the record for the selected date/time if in network view
      let rec;
      if (networkViewCategory && networkViewDate && networkViewTime && selectedHash.length === 0) {
        const timestamp = `${networkViewDate} ${networkViewTime}`;
        rec = allRecords.find((d) =>
          d.timestamp_utc && d.timestamp_utc.startsWith(timestamp)
        ) || allRecords[0] || {}; // Fallback to first record or empty
      } else {
        // Use first available record as default
        rec = allRecords[0] || {};
      }

      // Get the value based on category
      if (networkViewCategory === 'velocita') {
        return parseFloat(rec.speed) || 0;
      } else if (networkViewCategory === 'congestion') {
        return parseFloat(rec.congestion) || 0;
      } else if (networkViewCategory === 'anomaly') {
        return parseFloat(rec.anomaly) || 0;
      } else {
        // Default to speed
        return parseFloat(rec.speed) || 0;
      }
    });

    // Calculate min and max for color scale
    const validValues = values.filter(v => v > 0);
    if (validValues.length === 0) return;

    let minS = Math.min(...validValues);
    let maxS = Math.max(...validValues);

    // Ensure some spread in the scale
    if (minS === maxS) {
      minS = minS * 0.9;
      maxS = maxS * 1.1;
    }

    const scale = chroma
      .scale(networkViewCategory === 'velocita' ? ["red", "yellow", "green"] : ["green", "yellow", "red"])
      .domain([minS, maxS]);

    setSpeedDomain([minS, maxS]);
    setColorScale(() => scale);

    console.log(`Color scale updated: ${minS.toFixed(2)} - ${maxS.toFixed(2)}`);
  }, [geoData, networkViewCategory, networkViewDate, networkViewTime, selectedHash.length]);

  const styleFeature = (feature) => {
    const isSel = selectedHash.includes(feature.properties.hash);

    // Get the appropriate record based on network view settings
    const allRecords = feature.properties.allRecords || [];
    let rec;

    if (networkViewCategory && networkViewDate && networkViewTime && selectedHash.length === 0) {
      const timestamp = `${networkViewDate} ${networkViewTime}`;
      rec = allRecords.find((d) =>
        d.timestamp_utc && d.timestamp_utc.startsWith(timestamp)
      ) || allRecords[0] || {};
    } else {
      rec = allRecords[0] || {};
    }

    // Determine which value to use for coloring
    let value;
    let hasData = false;

    if (networkViewCategory) {
      if (networkViewCategory === 'velocita') {
        value = parseFloat(rec.speed) || 0;
        hasData = value > 0;
      } else if (networkViewCategory === 'congestion') {
        value = parseFloat(rec.congestion) || 0;
        hasData = value > 0;
      } else if (networkViewCategory === 'anomaly') {
        value = parseFloat(rec.anomaly) || 0;
        hasData = value > 0;
      }
    } else {
      // Default to speed
      value = parseFloat(rec.speed) || 0;
      hasData = value > 0;
    }

    // Determine color: purple if selected, darker cyan if no data, otherwise use color scale
    let color;
    if (isSel) {
      color = "purple";
    } else if (!hasData || allRecords.length === 0) {
      color = "#2C7A7B"; // Darker cyan/teal for roads without data - visible but not too bright
    } else {
      color = colorScale(value).hex();
    }

    return {
      color: color,
      weight: isSel ? 6 : 4,
      opacity: 1,
      lineCap: "round",
    };
  };

  const offsetSegmentiNegativi = (data, distanza = 4) => {
    const offsetFeatures = data.features.map((f) => {
      const segId = f.properties["Segment Id"];
      if (String(segId).startsWith("-")) {
        try {
          const offsetLine = turf.lineOffset(f, distanza, { units: "meters" });
          return { ...f, geometry: offsetLine.geometry };
        } catch (e) {
          console.warn("Offset fallito per segmento", segId);
          return f;
        }
      }
      return f;
    });
    return { ...data, features: offsetFeatures };
  };

  const onFeatureSelect = (hash, featureProperties) => {
    setSelectedHash((prevHash) => {
      // Normalize to array
      const currentRoads = Array.isArray(prevHash)
        ? prevHash
        : prevHash
        ? [prevHash]
        : [];

      // Check if this road is already selected
      const isAlreadySelected = currentRoads.includes(hash);

      if (isAlreadySelected) {
        // DESELECT: Remove this road
        const newHash = currentRoads.filter((h) => h !== hash);

        setSelectedFeature((prevFeatures) => {
          const currentFeatures = Array.isArray(prevFeatures)
            ? prevFeatures
            : prevFeatures
            ? [prevFeatures]
            : [];
          return currentFeatures.filter((f) => f.hash !== hash);
        });

        // If we're deselecting and no roads remain, close the sider
        if (newHash.length === 0 && !radarSelected) {
          setSiderSection(null);
        }

        return newHash;
      } else {
        // SELECT: Add this road (enforce 2-element total limit)
        const radarCount = radarSelected ? 1 : 0;
        const totalSelected = currentRoads.length + radarCount;

        // Close network view card when selecting a road
        if (currentRoads.length === 0 && networkViewCategory) {
          // Opening from network view - keep the same section but it will show road data
          // The section stays the same (velocita, congestion, anomaly) but shows road-specific data
        }

        if (totalSelected >= 2) {
          // At capacity (2 elements selected)
          // FIFO: Remove oldest element to make room

          if (currentRoads.length === 2) {
            // Have 2 roads → remove oldest road
            const newHash = [currentRoads[1], hash];
            setSelectedFeature((prevFeatures) => {
              const currentFeatures = Array.isArray(prevFeatures)
                ? prevFeatures
                : prevFeatures
                ? [prevFeatures]
                : [];
              return [currentFeatures[1], featureProperties];
            });
            return newHash;
          } else if (currentRoads.length === 1 && radarSelected) {
            // Have 1 road + 1 radar → remove radar to add 2nd road
            setRadarSelected(false);
            const newHash = [...currentRoads, hash];
            setSelectedFeature((prevFeatures) => {
              const currentFeatures = Array.isArray(prevFeatures)
                ? prevFeatures
                : prevFeatures
                ? [prevFeatures]
                : [];
              return [...currentFeatures, featureProperties];
            });
            return newHash;
          }
        }

        // Under capacity → just add it
        const newHash = [...currentRoads, hash];
        setSelectedFeature((prevFeatures) => {
          const currentFeatures = Array.isArray(prevFeatures)
            ? prevFeatures
            : prevFeatures
            ? [prevFeatures]
            : [];
          return [...currentFeatures, featureProperties];
        });
        return newHash;
      }
    });

    // Update dates based on the clicked hash - always select first date
    const dates = [
      ...new Set(
        dbData
          ?.filter((d) => d.hash === hash && d.date)
          .map((d) => d.date.split("T")[0])
      ),
    ].sort();

    // Always select the first available date
    if (dates.length > 0) {
      setSelectedDate(dates[0]);
    } else {
      setSelectedDate(null);
    }
  };

  const onRadarSelect = () => {
    setRadarSelected((prev) => {
      const willBeSelected = !prev;

      if (willBeSelected) {
        // SELECTING radar - enforce 2-element limit
        const currentRoads = Array.isArray(selectedHash)
          ? selectedHash
          : selectedHash
          ? [selectedHash]
          : [];
        const totalSelected = currentRoads.length; // radar not counted yet

        if (totalSelected >= 2) {
          // Have 2 roads → remove oldest road to make room for radar
          const newHash = currentRoads.slice(1);
          setSelectedHash(newHash);
          setSelectedFeature((prevFeatures) => {
            const currentFeatures = Array.isArray(prevFeatures)
              ? prevFeatures
              : prevFeatures
              ? [prevFeatures]
              : [];
            return currentFeatures.slice(1);
          });
        }
        // else: Have 0 or 1 roads → just add radar (total will be 1 or 2)
      }
      // DESELECTING radar → just remove it (don't touch roads)

      return willBeSelected;
    });
  };

  // const arco = dbData?.find((d) => d.hash === selectedHash);

  // Extract available dates from the traffic data
  const availableDates = useMemo(() => {
    if (!dbData || !selectedHash || selectedHash.length === 0) return [];

    const dates = new Set();
    dbData
      .filter((d) => selectedHash.includes(d.hash))
      .forEach((d) => {
        // Support both new and old date formats
        if (d.timestamp_utc) {
          // New format: "2025-05-10 07:50:23+00:00"
          const date = d.timestamp_utc.split(" ")[0];
          dates.add(date);
        } else if (d.date) {
          // Old format: "2024-11-22T00:00:00.000"
          const date = d.date.split("T")[0];
          dates.add(date);
        }
      });

    return Array.from(dates).sort();
  }, [dbData, selectedHash]);

  /*
  const selectedData = dbData
    ?.filter((d) => d.hash === selectedHash && d.date?.startsWith(selectedDate))
    ?.sort((a, b) => a.timestamp - b.timestamp)
    ?.map((d) => {
      const date = new Date(d.timestamp * 1000);
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      const orario = `${hh}:${mm}:${ss}`;

      const velocita =
        d.travel_time_in_seconds > 0
          ? (d.length_in_meters / d.travel_time_in_seconds) * 3.6
          : 0;

      return {
        time: orario,
        velocità: Math.round(velocita * 10) / 10,
        tempo_percorrenza: d.travel_time_in_seconds,
        tempo_storico: d.historic_traffic_travel_time_in_seconds,
        lunghezza_coda: d.traffic_length_in_meters,
      };
    });
  */

  const getPopupWidthClass = () => {
    if (siderSection === "video") return "width-video";
    if (siderSection === "proprieta") return "width-proprieta";
    // Network view cards are smaller
    if (siderSection === "velocita" && (!selectedHash || selectedHash.length === 0)) return "width-default";
    if (siderSection === "congestion" && (!selectedHash || selectedHash.length === 0)) return "width-default";
    if (siderSection === "anomaly" && (!selectedHash || selectedHash.length === 0)) return "width-default";
    if (siderSection === "velocita") return "width-proprieta";
    if (siderSection === "congestion") return "width-proprieta";
    if (siderSection === "anomaly") return "width-proprieta";
    if (siderSection === "ambientali") return "width-ambientali";
    if (siderSection === "accelerometrici") return "width-accelerometrici";
    if (siderSection === "audio") return "width-audio";
    if (siderSection === "confronto") return "width-proprieta";
    return "width-default";
  };

  return (
    <Layout
      className={`geojson-layout ${
        isMobile ? "geojson-layout-mobile" : "geojson-layout-desktop"
      }`}
    >
      {/**
       * Sidebar commented out for full-screen map
       * <SiderComponent
       *   isMobile={isMobile}
       *   collapsed={collapsed}
       *   setCollapsed={setCollapsed}
       *   siderSection={siderSection}
       *   selectedFeature={selectedFeature}
       *   arco={arco}
       *   availableDates={availableDates}
       *   selectedDate={selectedDate}
       *   setSelectedDate={setSelectedDate}
       *   selectedData={selectedData}
       * />
       */}

      <Layout className="geojson-inner-layout">
        <Content className="geojson-content">
          {/* Betwin Logo - Top Left */}
          <div className="betwin-logo-container">
            <img
              src={BetwinLogo}
              alt="Betwin Logo"
              className="betwin-logo-img"
            />
            <span className="betwin-logo-text">Betwin</span>
          </div>

          <div className="geojson-map-container">
            <MapComponent
              style={{
                padding: 0,
                borderRadius: 0,
                height: "100%",
                // keep part of the handle tappable even when closed
                paddingBottom: footerOpen ? FOOTER_HEIGHT : 0,
                overflow: "hidden",
                position: "relative",
              }}
              geoData={geoData}
              onFeatureSelect={onFeatureSelect}
              styleFeature={styleFeature}
              speedDomain={speedDomain}
              siderSection={siderSection}
              setSiderSection={setSiderSection}
              showDeckGL={showDeckGL}
              setShowDeckGL={setShowDeckGL}
              mapMode={mapMode}
              setMapMode={setMapMode}
              colorScale={colorScale}
              availableDates={availableDates}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedHash={selectedHash}
              setSelectedHash={setSelectedHash}
              setSelectedFeature={setSelectedFeature}
              onRadarSelect={onRadarSelect}
              radarSelected={radarSelected}
              setRadarSelected={setRadarSelected}
              footerOpen={footerOpen}
              footerHeight={FOOTER_HEIGHT}
              isLoadingGeoData={isLoadingGeoData}
              networkViewCategory={networkViewCategory}
              setNetworkViewCategory={setNetworkViewCategory}
              networkViewDate={networkViewDate}
              setNetworkViewDate={setNetworkViewDate}
              networkViewTime={networkViewTime}
              setNetworkViewTime={setNetworkViewTime}
              availableNetworkDates={availableNetworkDates}
              availableNetworkTimes={availableNetworkTimes}
            />
            {/** Popup card overlay with Sider content */}
            {mapMode === "mappa" && siderSection && (
              <div className={`geojson-popup-card ${getPopupWidthClass()}`}>
                <button
                  onClick={() => setSiderSection(null)}
                  className="geojson-popup-close-btn"
                  aria-label="Close"
                >
                  ✕
                </button>
                <SiderComponent
                  isMobile={true}
                  collapsed={false}
                  setCollapsed={() => {}}
                  siderSection={siderSection}
                  selectedFeature={selectedFeature}
                  networkViewDate={networkViewDate}
                  setNetworkViewDate={setNetworkViewDate}
                  networkViewTime={networkViewTime}
                  setNetworkViewTime={setNetworkViewTime}
                  availableNetworkDates={availableNetworkDates}
                  availableNetworkTimes={availableNetworkTimes}
                  networkViewCategory={networkViewCategory}
                  arco={selectedHash && selectedHash.length > 0
                    ? (() => {
                        const filteredData = dbData
                          ?.filter((d) => selectedHash.includes(d.hash))
                          .map((d) => {
                            // Normalize data format for compatibility with child components
                            const normalizedData = { ...d };

                            // Ensure date field exists
                            if (d.timestamp_utc && !d.date) {
                              // New format: convert timestamp_utc to date
                              normalizedData.date =
                                d.timestamp_utc.split(" ")[0] + "T00:00:00.000";
                            }

                            // Ensure timestamp field exists (Unix timestamp in seconds)
                            if (d.time && !d.timestamp) {
                              normalizedData.timestamp = parseInt(d.time);
                            }

                            // Parse numeric strings to numbers for consistency
                            if (typeof d.length_in_meters === "string") {
                              normalizedData.length_in_meters = parseFloat(
                                d.length_in_meters
                              );
                            }
                            if (typeof d.travel_time_in_seconds === "string") {
                              normalizedData.travel_time_in_seconds = parseFloat(
                                d.travel_time_in_seconds
                              );
                            }
                            if (
                              typeof d.historic_traffic_travel_time_in_seconds ===
                              "string"
                            ) {
                              normalizedData.historic_traffic_travel_time_in_seconds =
                                parseFloat(d.historic_traffic_travel_time_in_seconds);
                            }
                            if (typeof d.traffic_length_in_meters === "string") {
                              normalizedData.traffic_length_in_meters = parseFloat(
                                d.traffic_length_in_meters
                              );
                            }
                            if (
                              typeof d.live_traffic_incidents_travel_time_in_seconds ===
                              "string"
                            ) {
                              normalizedData.live_traffic_incidents_travel_time_in_seconds =
                                parseFloat(
                                  d.live_traffic_incidents_travel_time_in_seconds
                                );
                            }
                            if (typeof d.traffic_delay_in_seconds === "string") {
                              normalizedData.traffic_delay_in_seconds = parseFloat(
                                d.traffic_delay_in_seconds
                              );
                            }

                            return normalizedData;
                          }) || [];

                        // Check which selected roads are missing from filteredData
                        // and create minimal objects for them so components know they ARE selected
                        if (selectedHash && selectedHash.length > 0 && selectedFeature && selectedFeature.length > 0) {
                          // Get hashes that exist in filteredData
                          const hashesWithData = new Set(filteredData.map(d => d.hash));

                          // Find roads that are selected but have no data
                          const roadsWithoutData = selectedFeature.filter(
                            feature => !hashesWithData.has(feature.hash)
                          );

                          // Create minimal objects for roads without data
                          const minimalObjects = roadsWithoutData.map(feature => ({
                            hash: feature.hash,
                            // Include basic properties from GeoJSON
                            ...(feature.StreetName && { StreetName: feature.StreetName }),
                            ...(feature.Length && { length_in_meters: feature.Length }),
                            ...(feature.SpeedLimit && { speed_limit: feature.SpeedLimit }),
                          }));

                          // Combine data: roads with data + roads without data
                          return [...filteredData, ...minimalObjects];
                        }

                        return filteredData;
                      })()
                    : [] // Empty array when no road is selected
                  }
                  geoData={geoData}
                  availableDates={availableDates}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  radarSelected={radarSelected}
                  selectedData={selectedHash && selectedHash.length > 0
                    ? dbData
                        ?.filter((d) => {
                          if (!selectedHash.includes(d.hash)) return false;
                          if (!selectedDate) return false;

                          // Support both date formats
                          if (d.timestamp_utc) {
                            return d.timestamp_utc.startsWith(selectedDate);
                          } else if (d.date) {
                            return d.date.startsWith(selectedDate);
                          }
                          return false;
                        })
                        ?.sort((a, b) => {
                          const timeA = a.timestamp || parseInt(a.time) || 0;
                          const timeB = b.timestamp || parseInt(b.time) || 0;
                          return timeA - timeB;
                        })
                        ?.map((d) => {
                          const timestamp = d.timestamp || parseInt(d.time) || 0;
                          const date = new Date(timestamp * 1000);
                          const hh = String(date.getHours()).padStart(2, "0");
                          const mm = String(date.getMinutes()).padStart(2, "0");
                          const ss = String(date.getSeconds()).padStart(2, "0");
                          const orario = `${hh}:${mm}:${ss}`;

                          let velocita = 0;
                          if (d.speed) {
                            // New format has speed directly
                            velocita = parseFloat(d.speed);
                          } else if (
                            d.travel_time_in_seconds &&
                            parseFloat(d.travel_time_in_seconds) > 0
                          ) {
                            // Old format: calculate speed
                            velocita =
                              (parseFloat(d.length_in_meters) /
                                parseFloat(d.travel_time_in_seconds)) *
                              3.6;
                          }

                          return {
                            time: orario,
                            velocità: Math.round(velocita * 10) / 10,
                            tempo_percorrenza:
                              parseFloat(d.travel_time_in_seconds) || 0,
                            tempo_storico:
                              parseFloat(
                                d.historic_traffic_travel_time_in_seconds
                              ) || 0,
                            lunghezza_coda:
                              parseFloat(d.traffic_length_in_meters) || 0,
                          };
                        })
                    : [] // Empty array when no road is selected
                  }
                />
              </div>
            )}

            {/** Floating toggle button (visible in both states) */}
            <button
              onClick={() => setFooterOpen(!footerOpen)}
              className={`geojson-footer-toggle ${
                isMobile ? "geojson-footer-toggle-mobile" : ""
              }`}
              style={{ bottom: footerOpen ? FOOTER_HEIGHT - 15 : 12 }}
              aria-label="Toggle footer"
              title={footerOpen ? "Nascondi" : "Mostra"}
            >
              {footerOpen ? <FaLongArrowAltDown /> : <FaLongArrowAltUp />}
            </button>

            {footerOpen && (
              /** Bottom footer slider overlay */
              <div className="geojson-footer-slider">
                <div
                  className={`geojson-footer-content ${
                    isMobile ? "geojson-footer-content-mobile" : ""
                  }`}
                >
                  {/** Spacer to align content when handle removed */}
                  <div style={{ height: isMobile ? 6 : 8 }} />
                  <div
                    className={`geojson-footer-logos ${
                      screens.xs
                        ? "gap-xs"
                        : screens.sm
                        ? "gap-sm"
                        : screens.md
                        ? "gap-md"
                        : ""
                    }`}
                  >
                    <img
                      src={partner1}
                      alt="Exis Engineering Solutions"
                      className={`geojson-footer-logo ${
                        screens.s
                          ? "size-s"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                    <img
                      src={partner2}
                      alt="Spindox Digital Soul"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                    <img
                      src={partner3}
                      alt="OnAir"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                    <img
                      src={partner4}
                      alt="T&G Technology & Groupware"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />

                    <img
                      src={partner5}
                      alt="Swhard"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                    <img
                      src={finanziatore1}
                      alt="Finanziatore 1"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                    <img
                      src={finanziatore3}
                      alt="Finanziatore 3"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                    <img
                      src={finanziatore4}
                      alt="Finanziatore 4"
                      className={`geojson-footer-logo ${
                        screens.xs
                          ? "size-xs"
                          : screens.sm
                          ? "size-sm"
                          : screens.md
                          ? "size-md"
                          : "size-default"
                      }`}
                    />
                  </div>
                  <div
                    className={`geojson-footer-copyright ${
                      isMobile ? "size-xs" : "size-default"
                    }`}
                  >
                    © {new Date().getFullYear()} Tutti i diritti riservati.
                  </div>
                </div>
              </div>
            )}

            {/** Toggle is now handled inside the slider card */}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default GeoJson;
